"use client"

import { useRouter } from "next/navigation"
import Image from "next/image"
import { Button } from "@/components/ui/button"
import { Loader2 } from "lucide-react"
import { useState } from "react-safe"
import { brand } from "@/lib/brand"

export default function HomePage() {
  const router = useRouter()
  const [loading, setLoading] = useState(false)

  const handleOpenApplication = () => {
    setLoading(true)
    setTimeout(() => {
      router.push("/modules")
    }, 1500)
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-6 text-center">
      <div className="bg-surface shadow-lg rounded-xl p-8 w-full max-w-lg border border-border transition-all hover:shadow-xl">

        <div className="mb-6 flex justify-center">
          <Image
            src={brand.logoPath}
            alt={brand.name}
            width={100}
            height={100}
            priority
            className="h-auto max-w-[100px] object-contain"
          />
        </div>

        <h1 className="text-3xl font-semibold text-primary mb-2">
          {brand.name}
        </h1>
        <p className="text-text-muted mb-6">{brand.organization}</p>

        <Button
          className="mt-6 w-full text-lg font-medium bg-primary text-white hover:bg-primary-light transition-all"
          onClick={handleOpenApplication}
          disabled={loading}
        >
          {loading ? (
            <>
              <Loader2 className="animate-spin mr-2 h-5 w-5" /> Processing...
            </>
          ) : (
            "Open Application"
          )}
        </Button>
      </div>
    </div>
  )
}
